import React from 'react';
const ContactUsFinishedHeader = () => <h1>Thank you for your feedback!</h1>;

export default ContactUsFinishedHeader;
